<template>
  <div style="width: 85vw; height: 85vh; overflow: hidden;">
    <dv-loading v-if="loading" class="loading-container">Loading...</dv-loading>
    <div v-else class="board-container">
      <div class="board-content">
        <div class="content-top">
          <div class="content-top-left">
            <dv-border-box-1 style="height: 100%;">
              <ICurrentTable :tableData="iCurrentData" :max-height="'100%'" :scale="0.85"></ICurrentTable>
            </dv-border-box-1>
          </div>
          <div class="content-top-right">
            <div class="tankRow" v-for="(item, index) in tankData" :key="`tankRow${index}`">
              <div class="tankItem" v-for="(it, ix) in item" :key="`tankItem${ix}`">
                <tank :tankData="it"></tank>
              </div>
            </div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="bottom-left">
            <dv-border-box-8 style="height: 100%;">
              <WarningTable :tableData="warningData" :max-height="'100%'" :scale="0.85"></WarningTable>
            </dv-border-box-8>
          </div>
          <div class="bottom-right">
            <dv-border-box-1>
              <in-out-chart :chartData="inOutData"></in-out-chart>
            </dv-border-box-1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import InventoryBar1 from '../components/inventoryBar1'
import InventoryBar2 from '../components/inventoryBar2'
import InOutChart from '../components/inOutChart'
import StackingBar from '../components/stackingBar'
import WarningTable from '../components/warningTable'
import ICurrentTable from '../components/iCurrentTable'
import Tank from './tank'
import { mapActions } from 'vuex'

export default {
  name: 'lfdBoard',
  components: {
    InventoryBar1,
    InventoryBar2,
    InOutChart,
    WarningTable,
    StackingBar,
    Tank,
    ICurrentTable
  },
  data () {
    return {
      loading: true,
      timeText: '', // 时间
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      tankData: [
        // [
        //   {
        //     name: '罐A0001',
        //     material: '70道路沥青',
        //     new: 180,
        //     old: 160,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐A0002',
        //     material: '70道路沥青2',
        //     new: 1488,
        //     old: 2688,
        //     total: 3000,
        //     change: 1200
        //   },
        //   {
        //     name: '罐A0003',
        //     material: '70道路沥青3',
        //     new: 160,
        //     old: 180,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐A0004',
        //     material: '70道路沥青4',
        //     new: 280,
        //     old: 260,
        //     total: 300,
        //     change: 20
        //   }
        // ],
        // [
        //   {
        //     name: '罐B0001',
        //     material: '92#汽油',
        //     new: 180,
        //     old: 160,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐B0002',
        //     material: '92#汽油2',
        //     new: 180,
        //     old: 180,
        //     total: 200,
        //     change: 0
        //   },
        //   {
        //     name: '罐B0003',
        //     material: '92#汽油3',
        //     new: 160,
        //     old: 180,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐B0004',
        //     material: '92#汽油4',
        //     new: 2400,
        //     old: 2666,
        //     total: 5000,
        //     change: 266
        //   }
        // ],
        // [
        //   {
        //     name: '罐C0001',
        //     material: '70道路沥青',
        //     new: 180,
        //     old: 160,
        //     total: 200,
        //     change: 20
        //   },
        //   {
        //     name: '罐C0002',
        //     material: '70道路沥青2',
        //     new: 180,
        //     old: 180,
        //     total: 200,
        //     change: 0
        //   },
        //   {
        //     name: '罐C0003',
        //     material: '70道路沥青3',
        //     new: 160,
        //     old: 180,
        //     total: 200,
        //     change: 20
        //   }
        // ]
      ],
      stackingData: [
        {
          name: '成品油',
          data: new Array(12).fill(0)
        },
        {
          name: '碳材料',
          data: new Array(12).fill(0)
        },
        {
          name: '化工品',
          data: new Array(12).fill(0)
        },
        {
          name: '聚烯烃',
          data: new Array(12).fill(0)
        },
        {
          name: '沥青',
          data: new Array(12).fill(0)
        }
      ],
      inOutData: {
        xAxisData: [],
        monthTotal: new Array(moment().date()).fill(0),
        inQuantity: new Array(moment().date()).fill(0),
        outQuantity: new Array(moment().date()).fill(0),
        endingQuantityTotal: 0,
        inQuantityTotal: 0,
        outQuantityTotal: 0,
        openingQuantityTotal: 0
      },
      iCurrentData: [],
      warningData: []
    }
  },
  created () { },
  mounted () {
    this.init()
    // 看板添加横向滚动条
    this.$nextTick(() => {
      document.querySelector('.main-view').style.overflowX = 'scroll'
    })
  },
  beforeDestroy () { },
  methods: {
    ...mapActions(['queryLFDBoardData']),
    timeFn () {
      // 获取时间
      setInterval(() => {
        const now = new Date()
        this.timeText = `${now.toLocaleString()} ${this.weekday[now.getDay()]}`
      }, 1000)
    },
    async init () {
      this.loading = true
      try {
        this.timeFn()
        const result = await this.queryLFDBoardData({
          reservoirAreaCode: 'LFDK'
        })
        const { data } = result
        if (data) {
          const { itemTypeDtoList, oilTankDtoList, storageDayDtoList, totalDto, inventoryNumDtoList, forewarningShowList } = data
          if (Array.isArray(forewarningShowList) && forewarningShowList.length > 0) {
            this.warningData = forewarningShowList
          }
          if (Array.isArray(inventoryNumDtoList) && inventoryNumDtoList.length > 0) {
            this.iCurrentData = inventoryNumDtoList
          }
          if (Array.isArray(itemTypeDtoList) && itemTypeDtoList.length > 0) {
            itemTypeDtoList.forEach((item) => {
              const { month, quantity, type } = item
              const temp = this.stackingData.find((i) => i.name === type)
              temp.data.splice(month - 1, 1, quantity)
            })
          }
          if (Array.isArray(oilTankDtoList) && oilTankDtoList.length > 0) {
            const tankArr = oilTankDtoList.map((item) => {
              const {
                changeQuantity,
                endingQuantity,
                itemName,
                oilTankCode,
                openingQuantity,
                oilTankCapacity
              } = item
              return {
                name: oilTankCode,
                material: itemName,
                old: openingQuantity || 0,
                new: endingQuantity || 0,
                change: changeQuantity || 0,
                total: oilTankCapacity || 0
              }
            }).filter(tank => tank.new !== 0) // 不展示液位为0的罐
            this.convertTankData(tankArr)
          }
          if (
            Array.isArray(storageDayDtoList) &&
            storageDayDtoList.length > 0
          ) {
            storageDayDtoList.forEach((item) => {
              const { day, endingQuantity, inQuantity, outQuantity } = item
              this.inOutData.monthTotal.splice(day - 1, 1, endingQuantity)
              this.inOutData.inQuantity.splice(day - 1, 1, inQuantity)
              this.inOutData.outQuantity.splice(day - 1, 1, outQuantity)
            })
            this.inOutData.monthTotal = this.inOutData.monthTotal.slice(0, -1)
          }
          const { endingQuantityTotal, inQuantityTotal, outQuantityTotal, openingQuantityTotal } = totalDto || {}
          this.inOutData.endingQuantityTotal = endingQuantityTotal
          this.inOutData.inQuantityTotal = inQuantityTotal
          this.inOutData.outQuantityTotal = outQuantityTotal
          this.inOutData.openingQuantityTotal = openingQuantityTotal
          this.inOutData.xAxisData = this.getInOutXAxis()
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    convertTankData (data) {
      let tankArr = []
      for (let i = 0; i < data.length; i += 3) {
        tankArr.push(data.slice(i, i + 3))
      }
      this.tankData = tankArr
    },
    hideMenu () {
      this.$router.replace({ path: '/lfdBoard' })
    },
    getInOutXAxis () {
      let startDate = moment().startOf('month').format('MM/DD') // 当前月的第一天
      let currentDate = moment().subtract(2, 'days').format('MM/DD') // 前二天
      let dateArray = []

      // 循环从第一天到前一天
      for (
        let m = moment(startDate);
        m.isSameOrBefore(currentDate);
        m.add(1, 'days')
      ) {
        dateArray.push(m.format('MM/DD'))
      }
      console.log('11111111')
      console.log(dateArray)
      return dateArray
    }
  }
}
</script>

<style scoped lang="scss">
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 23px;
  color: #06f1ef;
  font-weight: bold;
  background: url('~@/assets/imgs/ydk/bg.png') no-repeat;
  background-size: 100% 100%;
}
.board-container {
  background: url('~@/assets/imgs/ydk/bg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 15px;
  box-sizing: border-box;
}

.board-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
    overflow: hidden;

    .content-top {
        display: grid;
        grid-template-columns: 2fr 3fr;
        gap: 15px;
        flex: 1;
        min-height: 0;
        overflow: hidden;
      }

      .content-top-right {
        background: rgba(0, 31, 63, 0.6);
        border: 1px solid #2862b7;
        border-radius: 8px;
        padding: 12px;
        box-sizing: border-box;
        overflow-y: auto; /* 为content-top-right添加垂直滚动条 */
        /* 自定义滚动条样式，适配深色主题 */
        &::-webkit-scrollbar {
          width: 6px; /* 滚动条宽度 */
        }
        &::-webkit-scrollbar-track {
          background: rgba(0, 31, 63, 0.4); /* 滚动条轨道背景色 */
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(6, 241, 239, 0.5); /* 滚动条滑块颜色，使用主题色 */
          border-radius: 3px;
          &:hover {
            background: rgba(6, 241, 239, 0.7); /* 滚动条滑块悬停颜色 */
          }
        }

        .section-title {
          color: #06f1ef;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 12px;
          text-align: center;
          padding-bottom: 6px;
          border-bottom: 2px solid #2862b7;
        }
      }

      .content-top-left {
        display: flex;
        flex-direction: column;
        gap: 15px;
        overflow: hidden;
      }

      .content-top-right {
        .tankRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          .tankItem {
            width: calc(33.333% - 10px);
            min-height: 70px;
            border: 1px dashed #2862b7;
            border-radius: 6px;
            padding: 3px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              border-color: #06f1ef;
            }
          }
        }
      }
    }

    .content-bottom {
        display: grid;
        grid-template-columns: 2fr 3fr;
        gap: 15px;
        flex: 1;
        min-height: 0;
        overflow: hidden;

        .bottom-left,
        .bottom-right {
          height: 100%;
          background: rgba(0, 31, 63, 0.6);
          border: 1px solid #2862b7;
          border-radius: 8px;
          padding: 12px;
          box-sizing: border-box;
          overflow: hidden;

          .section-title {
            color: #06f1ef;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 12px;
            text-align: center;
            padding-bottom: 6px;
            border-bottom: 2px solid #2862b7;
          }
        }

        .bottom-left {
          .dv-border-box-8 {
            height: 100%;
            display: flex;
            flex-direction: column;
            color: #fff;
          }
        }

        .bottom-right {
          .dv-border-box-1 {
            height: 100%;
            display: flex;
            flex-direction: column;
          }
        }
      }
</style>
